import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP, BACKEND_API_URL } from "@/utils/http-common"

export default {
  async getAll($, projectId, params = {}) {
    const path = `/event/${projectId}/authorisations`
    let results = (await HTTP.get(path, { params })).data
    return results
  },

  async get(actionId) {
    const path = `/event/authorisations/${actionId}`
    return (await HTTP.get(path)).data
  },

  async post(projectId, formData) {
    return new Promise((resolve, reject) => {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }

      HTTP.post(`event/${projectId}/authorisations`, formData, config)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },

  async put(id, formData) {
    const path = `/event/authorisations/${id}`
    const config = {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
    return (await HTTP.put(path, formData, config)).data
  },

  async authorize(authorisationId) {
    return new Promise((resolve, reject) => {
      HTTP.post(`event/authorisations/${authorisationId}/approved`)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },

  async reject(authorisationId) {
    return new Promise((resolve, reject) => {
      HTTP.post(`event/authorisations/${authorisationId}/rejected`)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },

  // async put(data) {
  //   const { id, ...others } = data
  //   const path = `/event/authorisations/${id}`
  //   return (await HTTP.put(path, others)).data
  // },

  async delete(actionId) {
    const path = `/event/authorisations/${actionId}`
    return (await HTTP.delete(path)).data
  },

  getReceiptUrl($, reservationId) {
    return new Promise((resolve, reject) => {
      const url = `${BACKEND_API_URL}/event/authorisations/${reservationId}/receipt`

      // Prepare request
      let xhr = new XMLHttpRequest()
      xhr.open("GET", url, true)
      xhr.setRequestHeader("authorization", "Token " + $.$store.state.app.user.key)
      xhr.setRequestHeader("X-Timezone-Name", $.$store.state.app.user.tzName)
      xhr.responseType = "blob"
      xhr.onload = function () {
        if (xhr.status === 200) resolve(xhr.response)
        else reject(xhr)
      }

      // Execute request
      xhr.send()
    })
  }
}
